import React from 'react'
import { withStyles, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import dialogButtons from './dialog.buttons'
import Tr from 'translations/Translations';
import CancelButton from '../components/CancelButton';

const style = theme => ({
	root: {

	},
	title: {
		textAlign: 'center'
	},
	content: {
		...theme.components.popup.smallContainer,
		'&>*': {
			'&:not(:first-child)': {
				marginTop: theme.spacing(1)
			},
			'&:last-child': {
				marginTop: theme.spacing(4)
			}
		}
	},
	border: {
		border: `1px solid ${theme.palette.common.white}`,
	}
})

function HelpDialog({
	classes,
	onClose,
	...other
}) {

	const handleClickButton = (action) => {
		onClose()
		action()
	}

	return (
		<Dialog
			onClose={onClose}
			{...other}
			PaperProps={{
				className: classes.border
			}}
		>
			<DialogTitle className={classes.title}>{Tr('help_center')}</DialogTitle>
			<DialogContent className={classes.content}>
				{dialogButtons.map(({ label, action, disabled }, i) => (
					<Button
						key={i}
						variant='contained'
						onClick={() => handleClickButton(action)}
						fullWidth
						disabled={disabled}
					>
						{label}
					</Button>
				))}
				<CancelButton onClick={onClose} />
			</DialogContent>
			<DialogActions></DialogActions>
		</Dialog>
	)
}

HelpDialog.propTypes = {
	classes: PropTypes.any,
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func,
}

HelpDialog.defaultProps = {
}

export default withStyles(style)(HelpDialog);